var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h3", { staticClass: "text-lg font-medium pl-4 mb-2" }, [
      _vm._v(_vm._s(_vm.$t("products.packages"))),
    ]),
    _c(
      "div",
      {
        staticClass:
          "bg-white rounded-lg p-4 mb-3 mx-4 w-[calc(100%-2rem)] hidden md:block",
      },
      [
        _c(
          "div",
          { staticClass: "grid grid-cols-4 gap-3" },
          _vm._l(_vm.firstLevelOptions, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "p-1 rounded-xl flex items-center justify-center cursor-pointer transition-all duration-200 text-sm font-medium",
                  _vm.currentFirstLevelIndex === index
                    ? "bg-orange-500 text-white border-2 border-orange-500"
                    : "bg-gray-100 text-gray-600 border-2 border-gray-200 hover:border-gray-300",
                ],
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handlePackageChange(index)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.isZh ? item.name : item.nameEn) + " ")]
            )
          }),
          0
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "bg-white rounded-lg p-3 mb-3 mx-4 w-[calc(100%-2rem)] md:hidden",
      },
      _vm._l(_vm.firstLevelOptionsRows, function (row, rowIndex) {
        return _c(
          "div",
          {
            key: rowIndex,
            staticClass: "grid grid-cols-4 gap-2.5 mb-3 last:mb-0",
          },
          _vm._l(row, function (item, itemIndex) {
            return _c(
              "div",
              {
                key: `${rowIndex}-${itemIndex}`,
                class: [
                  "py-1 px-0.5 rounded-xl flex items-center justify-center cursor-pointer transition-all duration-200 text-sm font-medium",
                  _vm.currentFirstLevelIndex === item.originalIndex
                    ? "bg-orange-500 text-white border-2 border-orange-500"
                    : "bg-gray-100 text-gray-600 border-2 border-gray-200 hover:border-gray-300",
                ],
                style: { gridColumn: `span ${item.colCount}` },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handlePackageChange(item.originalIndex)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.isZh ? item.name : item.nameEn) + " ")]
            )
          }),
          0
        )
      }),
      0
    ),
    _c("h3", { staticClass: "text-lg font-medium pl-4 mb-2" }, [
      _vm._v(_vm._s(_vm.$t("products.days"))),
    ]),
    _vm.secondLevelOptions.length > 0
      ? _c(
          "div",
          {
            staticClass:
              "bg-white rounded-lg p-3 mb-3 mx-4 w-[calc(100%-2rem)]",
          },
          [
            _c(
              "div",
              { staticClass: "grid grid-cols-5 gap-3" },
              _vm._l(_vm.secondLevelOptions, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: [
                      "p-1 rounded-xl flex items-center justify-center cursor-pointer transition-all duration-200 text-sm font-medium",
                      _vm.currentSecondLevelIndex === index
                        ? "bg-orange-500 text-white border-2 border-orange-500"
                        : "bg-gray-100 text-gray-600 border-2 border-gray-200 hover:border-gray-300",
                    ],
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleDaysChange(index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.isZh ? item.name : item.nameEn) + " "
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        )
      : _vm._e(),
    _c("h3", { staticClass: "text-lg font-medium pl-4 mb-2" }, [
      _vm._v(_vm._s(_vm.$t("products.quantity"))),
    ]),
    _c(
      "div",
      { staticClass: "bg-white rounded-lg p-3 mb-3 mx-4 w-[calc(100%-2rem)]" },
      [
        _c("van-stepper", {
          staticClass: "border-0",
          attrs: { min: "1", max: _vm.currentStock },
          model: {
            value: _vm.quantity,
            callback: function ($$v) {
              _vm.quantity = $$v
            },
            expression: "quantity",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bg-white rounded-lg p-3 mb-2 mx-4 w-[calc(100%-2rem)]" },
      [
        _c("h3", { staticClass: "text-lg font-medium mb-2" }, [
          _vm._v(_vm._s(_vm.$t("products.price"))),
        ]),
        _c("div", { staticClass: "text-[#ff7a00] line-through text-sm mb-1" }, [
          _vm._v("RM " + _vm._s(_vm.formatToYuan(_vm.currentMarketPrice))),
        ]),
        _c("div", { staticClass: "text-[#ff7a00] text-2xl font-bold" }, [
          _vm._v("RM " + _vm._s(_vm.formatToYuan(_vm.currentPrice))),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }